import { render, staticRenderFns } from "./ImageSettingsDesktop.vue?vue&type=template&id=4dc383cd&scoped=true&"
import script from "./ImageSettingsDesktop.vue?vue&type=script&lang=ts&"
export * from "./ImageSettingsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./ImageSettingsDesktop.vue?vue&type=style&index=0&id=4dc383cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc383cd",
  null
  
)

export default component.exports